import { Redirect } from "wouter";
import { useIsRestrictedFunder } from "@client/hooks/useIsRestrictedFunder";

/**
 * `/round/:roundId/funder` is router-only, never a page: send the funder to
 * their landing view. `replace`, like RoundBareRedirect, so the bare route
 * leaves no history entry — the grouped-round switcher navigates here
 * (RoundSwitcherAppBar), and without replace the header's Back landed on this
 * entry and bounced straight back to the review page (p9, 2026-10-21).
 */
export function FunderLandingRedirect({
  isRestrictedFunder,
}: {
  isRestrictedFunder: boolean;
}) {
  return (
    <Redirect
      to={isRestrictedFunder ? "/funder/decide" : "/funder/review"}
      replace
    />
  );
}

export function FunderBareRedirect() {
  return <FunderLandingRedirect isRestrictedFunder={useIsRestrictedFunder()} />;
}
